/* Presentation only. Do not intercept forms, issue requests or alter cart values. */
(() => {
  if (window.cnBagDesignV2) { window.cnBagDesignV2.refresh(); return; }
  let observer;
  let watchedMain;
  let scheduled = false;

  function sameStoreURL(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch { return null; }
  }

  function updatePresentation() {
    scheduled = false;
    const main = document.getElementById("MainContent");
    const design = main?.querySelector("[data-cn-bag-design]");
    const cartPage = main?.querySelector(".cart-page");
    if (!design || !cartPage) return;
    const isEmpty = cartPage.classList.contains("cart-page--empty");
    const title = cartPage.querySelector(".cart-title h1");
    if (title) Array.from(title.childNodes).forEach(node => {
      if (node.nodeType !== Node.TEXT_NODE) return;
      const replacement = {"Your cart is empty":"Your bag is empty","Your cart":"Your bag",Cart:"Your bag"}[node.textContent.trim()];
      if (replacement) node.textContent = replacement;
    });

    // Only our own informational copies are inserted or removed.
    function copyInto(parent, selector, enabled, first = false) {
      if (!parent) return;
      const existing = parent.querySelector(selector);
      if (!enabled) { existing?.remove(); return; }
      if (existing) return;
      const source = design.querySelector(selector);
      if (!source) return;
      const copy = source.cloneNode(true);
      if (selector === "[data-cn-bag-intro]") {
        const link = copy.querySelector("a");
        const destination = sameStoreURL(design.dataset.cnBagShopUrl || "/pages/shop");
        if (link && destination) link.setAttribute("href", destination.pathname + destination.search + destination.hash);
        else link?.remove();
      }
      if (first) parent.prepend(copy);
      else parent.append(copy);
    }
    const titleArea = cartPage.querySelector(".cart-page__title");
    copyInto(titleArea, "[data-cn-bag-intro]", !isEmpty);
    copyInto(titleArea, "[data-cn-bag-empty-intro]", isEmpty);
    copyInto(titleArea, "[data-cn-bag-empty-icon]", isEmpty, true);

    const summary = cartPage.querySelector(".cart-summary__inner");
    if (summary && !summary.querySelector(".cn-bag-summary-title")) {
      const heading = document.createElement("h2");
      heading.className = "cn-bag-summary-title";
      heading.textContent = "Order summary";
      summary.prepend(heading);
    }
    const hasPulse = !isEmpty && Array.from(cartPage.querySelectorAll(".cart-items__title")).some(link => {
      const url = sameStoreURL(link.getAttribute("href"));
      return url && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/nero-pulse\/?$/i.test(url.pathname);
    });
    copyInto(summary, "[data-cn-bag-plan]", hasPulse);
    copyInto(summary, "[data-cn-bag-summary-note]", !isEmpty && !hasPulse);

    cartPage.querySelectorAll(".cart-items__remove").forEach(button => {
      if (!/^Remove(?:\s|$)/.test(button.getAttribute("aria-label") || "")) return;
      if (button.querySelector(".cn-bag-remove-text")) return;
      if (button.querySelector(".button-text") || Array.from(button.childNodes).some(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() === "Remove")) return;
      const label = document.createElement("span");
      label.className = "cn-bag-remove-text";
      label.setAttribute("aria-hidden", "true");
      label.textContent = "Remove";
      button.append(label);
    });

    // Keep merchant destinations and translated copy; enhance the stock link only.
    const emptyLink = cartPage.querySelector(".cart-items__empty-button");
    if (emptyLink) {
      const href = emptyLink.getAttribute("href") || "";
      if (/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/all\/?$/i.test(href)) {
        const shopURL = sameStoreURL(design.dataset.cnBagShopUrl || "/pages/shop");
        if (shopURL) {
          emptyLink.setAttribute("href", shopURL.pathname + shopURL.search + shopURL.hash);
          const label = emptyLink.querySelector(".button-text");
          if (label && ["Continue shopping","Start shopping"].includes(label.textContent.trim())) label.textContent = "Shop Nero devices";
        }
      }
    }

    const countText = isEmpty ? "0" : cartPage.querySelector('[ref="cartItemCount"]')?.textContent.trim();
    if (/^\d+$/.test(countText || "")) {
      const count = Number(countText);
      document.querySelectorAll('.cn-site-header a[aria-label^="Shopping bag,"]').forEach(link => {
        const label = `Shopping bag, ${count} ${count === 1 ? "item" : "items"}`;
        const badge = link.querySelector(".cn-hd-count");
        if (badge && badge.textContent !== String(count)) badge.textContent = String(count);
        // An empty bag shows the icon alone.
        if (badge) badge.hidden = count === 0;
        // Compatibility for an older text-only header, without replacing its children.
        if (!badge) Array.from(link.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && /^Bag\s*\(\d+\)$/.test(node.textContent.trim())) node.textContent = `Bag (${count})`;
        });
        if (link.getAttribute("aria-label") !== label) link.setAttribute("aria-label", label);
      });
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updatePresentation);
  }
  function initialize() {
    const main = document.getElementById("MainContent");
    if (!main?.querySelector("[data-cn-bag-design]")) return;
    updatePresentation();
    if ("MutationObserver" in window && watchedMain !== main) {
      observer?.disconnect();
      watchedMain = main;
      observer = new MutationObserver(scheduleUpdate);
      observer.observe(main, {childList:true,characterData:true,subtree:true});
    }
  }
  window.cnBagDesignV2 = {refresh:initialize};
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, {once:true});
  else initialize();
  document.addEventListener("shopify:section:load", initialize);
})();
